// src/components/auth/WelcomePage.js
import React from 'react';
import { css } from '../../App';
import { PRODUCT_BRAND } from '../../appBranding';

function WelcomePage({ user, onContinue }) {
  const firstName = (user.name || user.email || "there").split(" ")[0];
  const bizName = user.businessName || "Business ERP";

  return (
    <><style>{css}</style>
      <div className="official-screen">
        <section className="official-brand-panel">
          <div>
            <img
              src={PRODUCT_BRAND.symbol}
              alt="Wavelines ERP"
              style={{ width: 70, height: 70, objectFit: "contain", borderRadius: 16, background: "#fff", padding: 6, marginBottom: 12, maxWidth: "100%" }}
            />
            <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase', opacity: .75, marginBottom: 8 }}>
              {PRODUCT_BRAND.name}
            </div>
            <h1>Welcome back, {firstName}</h1>
            <p>Your workspace is ready. Review the role, business, and session details below, then continue into the dashboard.</p>
          </div>
          <div className="official-proof">
            <span>✓ Live operational workspace</span>
            <span>✓ Notifications refresh automatically</span>
            <span>✓ Session protected by your Google sign-in</span>
          </div>
        </section>
        <main className="official-main-panel">
          <div className="official-card">
            <div className="official-eyebrow">New Sign-In Session</div>
            <h2>{bizName}</h2>
            <p>This landing check gives every client session a more official start and confirms the workspace context before work begins.</p>
            <div className="welcome-grid">
              <div className="welcome-metric"><span>Account</span><strong>{user.email}</strong></div>
              <div className="welcome-metric"><span>Role</span><strong>{user.role}</strong></div>
              <div className="welcome-metric"><span>Business</span><strong>{bizName}</strong></div>
            </div>
            <div className="official-actions">
              <button className="btn btn-primary" onClick={onContinue}>Enter Workspace</button>
            </div>
          </div>
        </main>
      </div></>
  );
}

export default WelcomePage;
